export enum NotificationType {
  PackingSlip = 'PackingSlip',
  Payment = 'Payment',
  OrderUpdate = 'OrderUpdate',
}

export interface PackingSlipNotificationPayload {
  deliveryDate: Date;
  orderNumber: string;
  packingSlipNumber: string;
}

export type NotificationPayload = PackingSlipNotificationPayload;
